export enum DisplayDensity {
  Default = 1,
  Compact = 2
}
